import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAddons, getProducts } from "services/locationCenter.services";

const useService = (facilityId, operationId, visible) => {
  const [products, setProducts] = useState([]);
  const [isFetchingProducts, setIsFetchingProducts] = useState(true);

  const [addOns, setAddons] = useState([]);
  const [isFetchingAddons, setIsFetchingAddons] = useState(false);

  const dispatch = useDispatch();

  const getFacilityOperationProducts = useCallback(() => {
    setIsFetchingProducts(true)
    dispatch(getProducts(facilityId, operationId)).then((data) => {
      setProducts(data);
      setIsFetchingProducts(false);
    });

  }, [facilityId, operationId])

  const setProduct = useCallback(
    (productId) => {
      setIsFetchingAddons(true);
      dispatch(getAddons(facilityId, operationId, productId)).then((data) => {
        setAddons(data);
        setIsFetchingAddons(false);
      });
    },
    [facilityId, operationId]
  );

  return {
    products,
    isFetchingProducts,
    setProduct,
    addOns,
    isFetchingAddons,
    getFacilityOperationProducts
  };
};

export default useService;
